'use client';

import { Box, List } from '@mui/material';
import type { Dispatch, SetStateAction } from 'react';
import { Link } from './components/Link';
import { Title } from './components/Title';
import type { TableOfContentsHeadingProps } from './types';
import { useDesktopToc } from './useDesktopToc';

type Props = {
  distanceToSectionWrapper: number;
  headingLevel: number;
  headings: TableOfContentsHeadingProps[];
  tocId: string;
  activeId: string;
  setActiveId: Dispatch<SetStateAction<string>>;
  fireNavigateToSectionPageAction: (
    overrideProps?: Record<string, string | object>,
    callback?: () => void,
  ) => void;
};

export function Desktop(props: Props) {
  const { headings, tocId, activeId } = props;
  const { handleClick, handleRef } = useDesktopToc(props);

  return (
    <Box
      id={tocId}
      sx={{
        display: { xs: 'none', md: 'block' },
        width: '100%',
        overflowY: 'auto',
        maxHeight: 'calc(100vh - 10px)',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
        position: 'sticky',
        top: 10,
      }}
      component="nav"
      aria-label="table of contents"
    >
      <Box
        sx={{
          padding: 2,
          paddingLeft: 3,
          marginBottom: 2,
          borderBottom: '4px solid',
          borderColor: 'primary.main',
          position: 'sticky',
          top: 0,
          zIndex: 1,
          backgroundColor: 'common.white',
        }}
      >
        <Title isHeading />
      </Box>
      <List component="ol" aria-labelledby="on-this-page" disablePadding>
        {headings.map(heading => (
          <List component="li" key={heading.id} disablePadding>
            <Link
              isSelected={activeId === heading.id}
              headingId={heading.id}
              handleRef={handleRef}
              onClick={handleClick}
            >
              {heading.header}
            </Link>
          </List>
        ))}
      </List>
    </Box>
  );
}
